<template>
<div>
  <div class="mainMenus"  v-if="getLocaltypes()==1"> 
 <!-- <el-container> -->
  <div class="Contentframe">
  <!-- <el-aside width="150px" class="leftmenu"> -->
 <!-- <i class="el-icon-s-unfold" @click="visible = true"></i> -->
    <div class="leftmenu">
      <LeftMenus :styles="styles" :active="active" :infoID="$route.query.infoID" ></LeftMenus>


  </div>
  <div class="rightContent" v-if="isTwo=='false'">
    <div class="menu"   v-for="(menus,index) in InfoMenusList" v-show="menus.isPublic4==true||$user!=null" :key="index" @click="getMenus(menus)" :class="{'menu_w':menus.fourType==1,'menu_h':menus.fourType==2,'menu_s':menus.fourType==0}">
        <div class="menus_images"><img :src="imagepath+menus.filePath" ></div>
   <div class="menus_Name">

    <!-- <el-tooltip :content="menus.infoFour_NAME"  placement="bottom" effect="light" :open-delay="750"	>
  <span class="span3">{{menus.infoFour_NAME}}</span>
</el-tooltip> -->
<span class="picTitle" :class="{'span_w':menus.fourType==1,'span_h':menus.fourType==2,'span_s':menus.fourType==0}"> {{menus.infoFour_NAME}}</span>
    </div>
    </div>

  </div>

 <div class="rightContent" v-if="isTwo=='true'">
    <div class="menu"  v-for="(menus,index) in InfoMenusList" :key="index+'12'"   @click="getMenus(menus)" v-show="menus.isPublic3==true||$user!=null" :class="{'menu_w':menus.type==1,'menu_h':menus.type==2,'menu_s':menus.type==0}">
        <div class="menus_images"><img :src="$imagepath+menus.filePath"></div>
   <div class="menus_Name">

    <!-- <el-tooltip   placement="bottom" effect="light" :open-delay="750"	>
  <span class="span3">{{menus.info_NAME}}</span>
</el-tooltip> -->
  <span class="picTitle" :class="{'span_w':menus.type==1,'span_h':menus.type==2,'span_s':menus.type==0}"> {{menus.info_NAME}}</span>
    </div>
    </div>

 </div>
   </div>
     </div>

     <div  v-if="getLocaltypes()==2">

      <div  v-for="(menus,index) in InfoMenusList" :key="index+'12'"   @click="getMenus(menus)" style="margin: 1% 1% 20px 1%;" >

        <div >
        <div  >
          <el-image  :src="$imagepath+menus.filePath" style="width: 100%;"></el-image >
          </div>
         <div  >
  <p style="text-align: center;"> {{menus.infoFour_NAME}}</p>
    </div>
  </div>

    </div>
     </div>
</div>



</template>

<script>
import {getLocaltype} from '../../../mainConfig/thu'
import LeftMenus from './../../LeftMenus.vue'
export default {
components:{LeftMenus},
created(){
  this.getInfoClassId()
},

data(){
  return{
    menusType:'',
    isTwo:'false',
    getInfoId:'',
    imagepath:'',
    threeMenus:'',
    infoList:[],
    InfoMenusList:[],
     info:{},
     active:[],
     info:{},
     styles:[],
  }
},
methods:{
  getLocaltypes(){
  return getLocaltype();
},
//侧边栏
  getInfoClassId(){
     this.styles=this.$route.query.styles
     this.active=this.$route.query.active
    this.threeMenus=this.$route.query.threeMenus
    
    // this.axios.post("/info/getInfo?infoID="+this.$route.query.infoID)
    // .then(resp => { 
    //                   if(resp.data.status == 1) {      
    //                     this.info=resp.data.result[0]                                                
    //                                console.log(resp.data.result[0])   
    //                                this.infoList=resp.data.result[0]   
    //                             }else {
    //                                alert("拿取数据失败")                                 
    //                             }
    //                         })
    //                         .catch((err) => {
    //                            // alert("出错了")
    //                             console.log(err)
    //                         }) 
  
                            if(this.threeMenus==undefined){//跳级
                              this.isTwo='true'
                              this.axios.post("/info/getMenusById","INFO_CLASSs_ID="+this.$route.query.two)
                      .then(resp => { 
                      if(resp.data.status == 1) {    
                        console.log(resp.data.result)
                         this.InfoMenusList=resp.data.result                                                        
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 

     
    }else{
      this.imagepath=this.$imagepath
     this.axios.post("/info/getInfoFour2","infoMenusId="+this.$route.query.threeMenus)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                         this.InfoMenusList=resp.data.result  
                         console.log( resp.data.result)                                                            
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
    }
  
  }, flishCom(){
    this.$router.go(0)
  },
  getMenus(data){
    console.log(data)
    if(data.router_Four==='#'){return}
if(this.isTwo=='false'){
  this.$router.push({  //核心语句
        path:'/'+data.router_Four,   //跳转的路径
        query:{           //路由传参时push和query搭配使用 ，作用时传递参数
          htmlpath:data.htmlPath_Four,
          infoID:this.$route.query.infoID,
          active:this.active,
          threeMenus:data.info_ID,
          styles:this.styles,
        }
      })
}else{
  this.$router.push({  //核心语句
        path:'/'+data.router,   //跳转的路径
        query:{           //路由传参时push和query搭配使用 ，作用时传递参数
          htmlpath:data.htmlPath,
          infoID:this.$route.query.infoID,
          active:this.active,
          threeMenus:data.info_ID,
          styles:this.styles,
        }
      })
}
    
  },
  selected(name){
   this.active = name;
}
}
}
</script >

<style scoped>

.Contentframe{
  width: 90%;
  margin: auto;
  display: flex;
  min-width: 1200px;
}

.mainMenus{
  width: 100%;
  height: 100%;
  margin: auto;
  display: flex;
}
.mainMenus{
  padding-left: 0px;
}
.menus{
  width:100%;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  flex-flow: row wrap;
   flex-wrap: wrap; 
   }
.menus:after {content: ""; width: 389.06px; }

.menuold{
  width: 250px;
  height: 300px;
  margin: 10px;
}

.menu{
  width: 200px;
  height: 250px;
  margin: 10px;
}
.menu2{
  width: 100%;
  margin: 1%;
}
.menu_w{
  width: 200px;
  height: 150px;
  margin: 10px;
}
.menu_h{
  width: 200px;
  height: 250px;
  margin: 10px;
}

.menu_s{
  width: 200px;
  height: 200px;
  margin: 10px;
}




.menus_images{
  width: 80%;
  height: 80%;
}
.menus_images2{
  /* width: 80%;
  height: 80%; */
}
.leftAside{
    position: fixed;
  }
.menus_Name
{
   height: 42px;
  margin-top: 10px;
}
img{
  width: 100%;
  height: 100%;
  overflow:hidden;
}
.span3{
  height: 42px;
  width:160px;
  font-size: 12px;
  /* line-height: 10px; */
  /* z-index: 2; */
 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    letter-spacing: 1px;
    white-space: normal;
    word-break: break-all;     

  /* word-wrap: break-word; */
    
}
.active {
     border-bottom: 4px solid #0065bd;
 }

 .leftmenu
 {
   padding-left:15px;
     background:#0065bd;
   color:black;
   margin-top: 40px;
   margin-right: 20px;
   height:500px;
   width:20%;
   min-width: 193px;
   padding: 20px;
 }

 .firstmenu
 {
   font-weight: 500;
   font-size: 18px;
   padding-top: 10px;
   border-left: 8px solid #ffd04b;
   
 }

 
 .firstsubMenu
 {
   width: 100%;
    height: 40px;
    line-height: 40px;
    color: #010544;
    padding: 0 10px;
    font-size: 18px;
    font-weight: 600;

     border-left: 6px solid #0065bd;
    /* border-bottom: 1px solid #ecebeb; */
}

  .submenu
 {
   font-weight: 400;
   font-size: 16px;
    margin-left: 10px;
    color: black;
    /* border-bottom: 2px solid #ecebeb */
   
 }

 .submenunew
 {
    width: 100%;
    font-size: 16px;
    line-height: 16px;
    color: #010544;
 

    border-width: 60px;
   
    border-style: solid;
    border-color: transparent transparent transparent #E362D5;
    margin-left:6px;
    padding: 1px 1px;
    display: flex;
    align-items: center;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
 }

 .rightContent{
  width: 80%;
  margin-left:50px;
    width:100%;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  flex-flow: row wrap;
   flex-wrap: wrap; 
   margin-top: 30px;
   margin-left: 50px;

}

  .router-link-active {     
   text-decoration: none;
   border-block-color: 2px;
 }
 
a{
  color:white;
  text-decoration: none;
}
/* ul li{
  text-decoration: none;
} */
.con {
    display: true;
    position: relative;
    bottom: 47px;
    left: 50%;
    z-index: 1000;
    margin-left: -40px;
    margin-top: 60px;
    width: 80px;
}

.span_h{
  height: 42px;
  width:160px;
  font-size: 12px;
  /* line-height: 10px; */
  /* z-index: 2; */
 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    letter-spacing: 1px;
    white-space: normal;
    word-break: break-all;
    align-content: center;  
    text-align: center;

  /* word-wrap: break-word; */
    
}
.span_w{
  height: 42px;
  width:240px;
  font-size: 12px;
  /* line-height: 10px; */
  /* z-index: 2; */
 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    letter-spacing: 1px;
    white-space: normal;
    word-break: break-all;
    align-content: center;  
    text-align: center;

  /* word-wrap: break-word; */
    
}

.span_s{
  height: 42px;
  width:240px;
  font-size: 12px;
  /* line-height: 10px; */
  /* z-index: 2; */
 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    display: -webkit-box;
    overflow: hidden;
    letter-spacing: 1px;
    white-space: normal;
    word-break: break-all;
    align-content: center;  
    text-align: center;

  /* word-wrap: break-word; */
    
}

</style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/InfoFour.vue